import React from 'react'
import PageContainer from '../../Components/PageContainer'
import {
    useStripe,
} from "@stripe/react-stripe-js";
import { useState, useEffect } from 'react';
import Spinner from '../../Components/Spinner';
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from '@stripe/stripe-js';
import { useNavigate } from 'react-router';
import { auth, firestore } from '../../firebase';
import { doc, onSnapshot } from 'firebase/firestore';

const stripePromise = loadStripe("pk_test_51L5UaHEgIJbVeIr3GLpEVipkn58ePJ44LfVOlmuG9OhETCl5jXKCh07uEKKmdoYmnSi63LOd74iutcsULRIbRDgt00WWBMBlfr");

export default function Order() {
    useEffect(() => {
        if (!auth.currentUser) {
            return window.location.replace("/login")
        }
        const unsubscribe = onSnapshot(doc(firestore, "users", auth.currentUser.uid), (newDoc) => {
            if (newDoc.data().isPro) {
                window.location.replace("/home")
                unsubscribe()
            }
        })
    }, [])
    const OrderInfoRenderer = () => {
        const stripe = useStripe();
        const [status, setStatus] = useState("requires_payment_method")
        const [id, setID] = useState("hfuisHSUIUGISO")
        const navigate = useNavigate()
        useEffect(() => {
            if (!stripe) {
                return;
            }

            const clientSecret = new URLSearchParams(window.location.search).get(
                "payment_intent_client_secret"
            );

            if (!clientSecret) {
                return;
            }

            stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
                setStatus(paymentIntent.status)
                setID(paymentIntent.id.substring(3, paymentIntent.id.length))
            });
        }, [stripe]);
        if (status) {
            if (status === "succeeded") {
                return (
                    <div className='flex aic jcc fdc' style={{ width: "100%", height: "100vh" }}>
                        <Spinner style={{ minHeight: 100 }} />
                        <p style={{ fontWeight: "bold", opacity: .6, marginTop: 0 }}>Processing your order...</p>
                    </div>
                )

            } else if (status === "processing") {
                return (
                    <PageContainer>
                        <div className='flex aic jcc fdc' style={{ width: "100%", height: "100%" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" height="70px" viewBox="0 0 24 24" width="70px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z" /></svg>
                            <h1 style={{ marginBottom: 10 }}>Payment Processing</h1>
                            <p style={{ opacity: .6, margin: 0, fontWeight: "bold" }}>#{id}</p>
                            <button onClick={() => navigate("/home")} style={{ marginTop: 20 }} className='b2'>Return Home</button>
                        </div>
                    </PageContainer>
                )
            } else if (status === "requires_payment_method") {
                return (
                    <PageContainer>
                        <div className='flex aic jcc fdc' style={{ width: "100%", height: "100%" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" height="70px" viewBox="0 0 24 24" width="70px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z" /></svg>
                            <h1 style={{ marginBottom: 10 }}>Payment Processing</h1>
                            <p style={{ opacity: .6, margin: 0, fontWeight: "bold" }}>#{id}</p>
                            <button onClick={() => navigate("/home")} style={{ marginTop: 20 }} className='b2'>Return Home</button>
                        </div>
                    </PageContainer>
                )
            }
        } else {
            return (
                <div style={{ width: "100%", height: "100%", position: "absolute", top: 0, left: 0 }} className="flex aic jcc fdc">
                    <Spinner style={{ minHeight: 100 }} />
                    <p style={{ fontWeight: " bold", opacity: .6 }}>Getting <span style={{ color: "#0074D9" }}>PRO</span> ready for you...</p>
                </div>
            )
        }
    }
    return (
        <Elements stripe={stripePromise}>
            <OrderInfoRenderer />
        </Elements>
    )

}
